
import { Component, DestroyRef, EventEmitter, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { QueueTypes } from '@core/enumeration';
import { QueueService } from '@core/service';
import { UserConfigService } from '@core/service/user-config.service';
import { SharedService } from '@shared/services/shared.service';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';

@Component({
    selector: 'app-queue-action-buttons',
    templateUrl: './queue-action-buttons.component.html',
    styleUrls: ['./queue-action-buttons.component.scss'],
    imports: [
    FormsModule,
    ButtonModule,
    SelectModule
]
})
export class QueueActionButtonsComponent implements OnInit {
  queueTypes: QueueTypes[] = [];

  @Output() resetData = new EventEmitter<void>();
  @Output() clear = new EventEmitter<void>();

  selectedQueueType?: QueueTypes;

  constructor(
    private destroyRef: DestroyRef,
    private queueService: QueueService,
    private userConfigService: UserConfigService,
    private readonly shellService: SharedService
  ) {
  }

  ngOnInit() {
    this.queueService.queueTypes
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((types) => this.queueTypes = types);

    this.queueService.activeQueueType
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((type) => this.selectedQueueType = type);
  }

  resetSelection() {
    this.resetData.emit();
    this.shellService.broadcastMessage('Queue.Reload', null);
  }

  clearAll() {
    this.clear.emit();
    this.shellService.broadcastMessage('Queue.ClearFilters', null);
  }

  setActiveQueueType(type: QueueTypes) {
    this.userConfigService.saveCurrentQueue(type);
    this.queueService.setActiveQueueType(type);
  }
}
